import React, { useEffect } from 'react';

// The canonical Privacy Policy now lives at /privacy-policy.html — a standalone
// HTML/CSS/JS page (required to be publicly accessible without JS rendering for
// A2P 10DLC campaign verification). This route redirects for backward compatibility.
const PrivacyPolicy: React.FC = () => {
  useEffect(() => {
    window.location.replace('/privacy-policy.html');
  }, []);

  return (
    <div className="min-h-screen bg-background-primary flex items-center justify-center">
      <p className="text-text-secondary">
        Redirecting to our{' '}
        <a href="/privacy-policy.html" className="text-gold-500 hover:text-gold-400 underline">
          Privacy Policy
        </a>
        …
      </p>
    </div>
  );
};

export default PrivacyPolicy;
